const initialState = {
  loading: false,
  data: [],
  error: null,
};

const bannerCarouselReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CAROUSEL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_CAROUSEL_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_CAROUSEL_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default bannerCarouselReducer;
